import { gql } from '@apollo/client';

export const QUERY_NIVEAU_FILIERE = gql`
  query getNiveauAndFilliere {
    niveaux {
      data {
        id
        attributes {
          name
        }
      }
    }
    fillieres {
      data {
        id
        attributes {
          name
        }
      }
    }
  }
`;
